import { AnyAction } from "redux";

import { Case, Slide } from "pwapi";

import { FETCH_LIS_CASE_REQUEST, FETCH_LIS_CASE_SUCCESS } from "../constants";

export interface SlidesState {
  [key: number]: SlideState;
}

interface SlideState extends Omit<Slide, "flags" | "metadata"> {
  flags?: Slide["flags"];
  metadata?: Slide["metadata"];
}

const reduceCase = (payload: Case) => {
  const { slides } = payload;

  return slides
    ? slides.reduce(
        (acc: SlidesState, slide) => ({
          ...acc,
          [slide.id || 0]: slide as SlideState,
        }),
        {}
      )
    : {};
};

export const AdminSlidesReducer = (
  state: SlidesState = {},
  action: AnyAction
): SlidesState => {
  switch (action.type) {
    case FETCH_LIS_CASE_REQUEST:
      return {};
    case FETCH_LIS_CASE_SUCCESS:
      return reduceCase(action.payload.response);
    default:
      return state;
  }
};
